/**
 * Fragment de routes du paquet v9-p03-factures (vague V9 ; fragment `v9-<sous>` par paquet, constat K11 de la fiche V9).
 * Composants chargés à la demande (règle de chargement du registre). Routes neuves :
 *  - `/org/abonnement/factures` → organisation-factures ;
 *  - `/org/abonnement/factures/:factureId` → organisation-facture-fiche ;
 *  - `/org/abonnement/coordonnees` → organisation-coordonnees-facturation ;
 *  - `/plateforme/facturation/indicateurs` → plateforme-facturation-indicateurs ;
 *  - `/plateforme/organisations/:organisationId/facturation` → plateforme-organisation-facturation ;
 *  - `/plateforme/organisations/:organisationId/facturation/reglement` → dialogue-enregistrer-un-reglement ;
 *  - `/plateforme/organisations/:organisationId/litiges/:litigeId` → plateforme-litige-fiche ;
 *  - `/plateforme/parametres/facturation` → plateforme-parametres-facturation.
 * Les écrans de plateforme reçoivent `superAdmin` (rôle de plateforme de la session) : le contexte de la règle de
 * plateforme en dépend, comme le résolveur de la passerelle.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationFactures = lazy(() => import('../ecrans/v9/factures/OrganisationFactures'))
const OrganisationFactureFiche = lazy(() => import('../ecrans/v9/factures/OrganisationFactureFiche'))
const OrganisationCoordonneesFacturation = lazy(() => import('../ecrans/v9/factures/OrganisationCoordonneesFacturation'))
const PlateformeFacturationIndicateurs = lazy(() => import('../ecrans/v9/factures/PlateformeFacturationIndicateurs'))
const PlateformeOrganisationFacturation = lazy(() => import('../ecrans/v9/factures/PlateformeOrganisationFacturation'))
const DialogueEnregistrerUnReglement = lazy(() => import('../ecrans/v9/factures/DialogueEnregistrerUnReglement'))
const PlateformeLitigeFiche = lazy(() => import('../ecrans/v9/factures/PlateformeLitigeFiche'))
const PlateformeParametresFacturation = lazy(() => import('../ecrans/v9/factures/PlateformeParametresFacturation'))

function ecran(Composant: ComponentType<{ session: Session; superAdmin?: boolean }>) {
  return ({ session, superAdmin, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} superAdmin={superAdmin} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v9-factures',
  routes: [
    { chemin: '/org/abonnement/factures', element: ecran(OrganisationFactures) },
    { chemin: '/org/abonnement/factures/:factureId', element: ecran(OrganisationFactureFiche) },
    { chemin: '/org/abonnement/coordonnees', element: ecran(OrganisationCoordonneesFacturation) },
    { chemin: '/plateforme/facturation/indicateurs', element: ecran(PlateformeFacturationIndicateurs) },
    { chemin: '/plateforme/organisations/:organisationId/facturation', element: ecran(PlateformeOrganisationFacturation) },
    { chemin: '/plateforme/organisations/:organisationId/facturation/reglement', element: ecran(DialogueEnregistrerUnReglement) },
    { chemin: '/plateforme/organisations/:organisationId/litiges/:litigeId', element: ecran(PlateformeLitigeFiche) },
    { chemin: '/plateforme/parametres/facturation', element: ecran(PlateformeParametresFacturation) },
  ],
}
